export default __webpack_public_path__ + "static/charMissile-a2708a670f9e580bb255ea3220346ce1.png";